import { BookOpen } from "lucide-react";
import HelpSearchBar from "./HelpSearchBar";

interface HelpCenterHeroProps {
  title: string;
  subtitle: string;
  searchQuery: string;
  onSearchChange: (query: string) => void;
}

const HelpCenterHero = ({ title, subtitle, searchQuery, onSearchChange }: HelpCenterHeroProps) => {
  return (
    <div className="relative bg-gradient-to-br from-primary/10 via-background to-background border border-border rounded-lg p-8 md:p-12 mb-8">
      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
            <BookOpen className="h-6 w-6 text-primary" />
          </div>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
          {title}
        </h1>
        <p className="text-lg text-muted-foreground mb-8">
          {subtitle}
        </p>
        <div className="max-w-2xl mx-auto">
          <HelpSearchBar value={searchQuery} onChange={onSearchChange} />
        </div>
      </div>
    </div>
  );
};

export default HelpCenterHero;
